import { takeLatest, put } from 'redux-saga/effects';
import { successAction, START_SESSION, UPDATE_COLUMNS } from '../types';
import { getPermission, getColumns } from '../actions/user';

function* handleStartSession() {
  yield put(getPermission());
  yield put(getColumns());
}

function* handleUpdateColumns() {
  yield put(getColumns());
}

function* watchStartSession() {
  yield takeLatest(successAction(START_SESSION), handleStartSession);
}

function* watchUpdateColumns() {
  yield takeLatest(successAction(UPDATE_COLUMNS), handleUpdateColumns);
}

export default [watchStartSession, watchUpdateColumns];
